// extracted by mini-css-extract-plugin
module.exports = {"root":"DocumentsIcon_root__1IfvV","icon":"DocumentsIcon_icon__dkNCN","delete":"DocumentsIcon_delete__12rQ6"};